import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
const carouselOptions = {
  navigationEnabled: true,
  navigationNextLabel: "Next",
  navigationPrevLabel: "Prev",
  paginationEnabled: false,
  perPage: 1
};
import { Carousel, Slide } from "vue-carousel";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import CoApplicantCarouselItem from "./co-applicant-carousel-item";
import { ADD_CO_APPLICANT, REMOVE_CO_APPLICANT, UPDATE_CO_APPLICANT } from "@Broker/@Modules/clients/board/store/board-actions";
import CoApplicantsInfoLoader from "./co-applicants-info-loader";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CoApplicantsInfo",
  components: {
    CoApplicantCarouselItem,
    Carousel,
    Slide,
    InlinePrompt,
    CoApplicantsInfoLoader,
    CollapsibleCard
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      carouselOptions,
      timer: 0,
      selectedCoApp: ""
    };
  },
  computed: {
    coApplicants() {
      var _this$profile;
      return (_this$profile = this.profile) == null ? void 0 : _this$profile.coApplicants;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [ADD_CO_APPLICANT, REMOVE_CO_APPLICANT, UPDATE_CO_APPLICANT])), {}, {
    setCurrentCoApp() {
      this.showCollapse();
      const index = this.$refs.carousel.currentPage;
      this.selectedCoApp = this.coApplicants[index];
    },
    async saveOnType() {
      const isValid = !this.$refs.item.some(data => data.$v.$invalid);
      if (!isValid) return;
      this.$emit("save");
    },
    clearTimer() {
      clearTimeout(this.timer);
    },
    handleSubmit() {
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        this.saveOnType();
      }.bind(this), 800);
    },
    async deleteCurrentApplicant() {
      const index = this.$refs.carousel.currentPage;
      if (this.coApplicants.length > 1) {
        await this.REMOVE_CO_APPLICANT({
          id: this.clientProfileId,
          index
        });
      } else {
        this.UPDATE_CO_APPLICANT({
          id: this.clientProfileId,
          index,
          payload: {}
        });
      }
      $("#delete-co-applicant-modal").modal("hide");
      this.saveOnType();
    },
    async addCoApplicant() {
      this.showCollapse();
      await this.ADD_CO_APPLICANT({
        id: this.clientProfileId
      });
      this.$refs.carousel.goToLastSlide();
    },
    formatTimeAgo(value) {
      return this.$options.filters.formatTimeAgo(value);
    },
    showCollapse() {
      this.$refs.collapseCoAppsInfo.handleShow();
    }
  })
});